import React, { useCallback, useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as GridConfigApi from '../../store/grid-config.api';
import ModalPortal from '../../components/modal-portal';
import { SaveFilterViewModal } from '../../components/modals/save-filterview-modal-service';
import { FulfillmentContext } from '../../shipping/fulfillments/context';
import { saveUserSettingGridConfig } from '../../store/user/user.actions';
import { useSelectedShippingViewId } from '../../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';

export const SaveFulfillmentsFilterViewModalContainer = ({ onClose }) => {
  const { savedFilterViews, customFilterView, columnConfiguration, saveFilterView } = useContext(FulfillmentContext);
  const dispatch = useDispatch();
  const viewId = useSelectedShippingViewId();
  const filterViewsForCurrentGrid = useMemo(
    () => savedFilterViews.filter((view) => view.gridViewId === viewId),
    [savedFilterViews, viewId],
  );

  const saveNewFilterViewRequest = useCallback(
    (newFilterView) => {
      GridConfigApi.saveNewFulfillmentsGridConfig(newFilterView).then((gridConfig) => {
        saveFilterView(gridConfig);
        dispatch(saveUserSettingGridConfig('fulfillments', viewId, gridConfig.filterViewId, columnConfiguration));
      });
      onClose();
    },
    [onClose, saveFilterView, columnConfiguration, viewId, dispatch],
  );

  const saveExistingFilterViewRequest = useCallback(
    (viewWithNewFilters) => {
      GridConfigApi.saveExistingFulfillmentsGridConfig(viewWithNewFilters).then(() => {
        saveFilterView(viewWithNewFilters);
        dispatch(saveUserSettingGridConfig('fulfillments', viewId, viewWithNewFilters.filterViewId, columnConfiguration));
      });
      onClose();
    },
    [onClose, saveFilterView, columnConfiguration, dispatch, viewId],
  );
  return (
    <ModalPortal onClose={onClose}>
      <SaveFilterViewModal
        closeModal={onClose}
        currentGridViewId={viewId}
        customFilterView={customFilterView}
        savedFilterViews={filterViewsForCurrentGrid}
        saveExistingFilterViewRequest={saveExistingFilterViewRequest}
        saveNewFilterViewRequest={saveNewFilterViewRequest}
      />
    </ModalPortal>
  );
};

SaveFulfillmentsFilterViewModalContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
};
